module.exports = __webpack_public_path__ + "assets/img/eoin_newell.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eoin_newell.jpg
// module id = 1927
// module chunks = 0